/** Google OAuth authorization-code redirect (avoids GIS JavaScript-origin checks). */

const RETURN_PATH_KEY = 'quilty_google_oauth_return';

export function googleOAuthRedirectUri(origin?: string): string {
  const base = origin ?? (typeof window !== 'undefined' ? window.location.origin : '');
  return `${base}/api/auth/google/callback`;
}

export function rememberGoogleOAuthReturnPath(returnPath?: string): void {
  if (typeof sessionStorage === 'undefined') return;
  const path =
    returnPath ??
    (typeof window !== 'undefined'
      ? `${window.location.pathname}${window.location.search}`
      : '');
  if (path) {
    sessionStorage.setItem(RETURN_PATH_KEY, path);
  }
}

export function consumeGoogleOAuthReturnPath(): string | null {
  if (typeof sessionStorage === 'undefined') return null;
  const path = sessionStorage.getItem(RETURN_PATH_KEY);
  if (path) {
    sessionStorage.removeItem(RETURN_PATH_KEY);
  }
  return path;
}

export function startGoogleOAuth(clientId: string, returnPath?: string): void {
  rememberGoogleOAuthReturnPath(returnPath);
  const redirectUri = googleOAuthRedirectUri();
  const scope = encodeURIComponent('openid email profile');
  const authUrl =
    `https://accounts.google.com/o/oauth2/v2/auth?` +
    `client_id=${encodeURIComponent(clientId)}` +
    `&response_type=code` +
    `&redirect_uri=${encodeURIComponent(redirectUri)}` +
    `&scope=${scope}` +
    `&prompt=select_account`;

  window.location.href = authUrl;
}
